import {Answer} from "@/api/types.ts";
import { Flex, Grid } from "@keyslabor/shared/ui";
import {CollapsibleQuestionAnswer} from "./CollapsibleQuestionAnswer.tsx";
import VideoPlayer from "@/components/VideoPlayer";
import styled from "styled-components";
import { splitTextBySeparator } from "@/utils/splitTextBySeparator";

const maxVideoWidth = '300px';

export const VideoWrapper = styled(Flex)`
    align-self: center;
    padding: 8px;
    background-color: white;
    border-radius: 10px;
    box-shadow: 0px 4px 4px 0px rgba(20, 57, 128, 0.1);
    max-width: ${maxVideoWidth}; 
    min-height: 0;
`

export const QuestionWrapper = styled(Grid)`
    grid-template-rows: minmax(72px, max-content) 48px auto;
    grid-template-columns: 100%;
    gap: 10px;
    justify-items: center;
`

export const Question = ({
    answer,
    questionNumber,
    totalQuestions,
    isTranslated,
    videoSrc,
}: {
    answer: Answer;
    questionNumber: number;
    totalQuestions: number;
    isTranslated: boolean;
    videoSrc: string | undefined;
}) => {
    return (
      <QuestionWrapper>
        <Flex flexDirection="column" mt="0px">
          <Flex fontSize="20px" fontWeight="700" color="#143980" flexCenter>
            {`Question ${questionNumber} out of ${totalQuestions}`}
          </Flex>
          <Flex
            mt="5px"
            backgroundColor="white"
            borderRadius="10px"
            boxShadow="0px 4px 4px 0px rgba(20, 57, 128, 0.1)"
            p="7px 10px"
            fontSize="14px"
            width="335px"
            color="black"
            fontWeight="700"
            flexDirection="column"
          >
            {getQuestionText(answer, isTranslated).map((line, i) => (
              <span key={i}>{line}</span>
            ))}
          </Flex>
        </Flex>
        <Flex flexDirection="column" width="100%">
          <CollapsibleQuestionAnswer
            mt="5px"
            answer={answer}
            isTranslated={isTranslated}
          />
        </Flex>
        <VideoWrapper>
          <VideoPlayer
            src={videoSrc}
            controls
            showSlowNetworkWarning
            showPlayOverlay
          />
        </VideoWrapper>
      </QuestionWrapper>
    );
};

function getQuestionText(answer: Answer, isTranslated: boolean): string[] {
  if (!answer.question_text) {
    return ['No question provided'];
  }

  const text = isTranslated && answer.question_text_english
    ? answer.question_text_english
    : answer.question_text;

  return splitTextBySeparator(text);
}
